<template>

   <section>
      <GmapMap :center="center" :zoom="12" style="width:100%; height: 80vh;">
         <!-- Ventana de información -->
         <gmap-info-window v-if="infoWinOpen && markers[select_point]" :options="infoOptions" :position="infoWindowPos"
            :opened="infoWinOpen" @closeclick="infoWinOpen = false">
            <v-card flat class="py-0 my-0">
               <v-card-title class="onSurface--text font-weight-bold text-capitalize">
                  {{ markers[select_point].infoText.nombre }}
               </v-card-title>
               <v-card-text class="sidebar__point--text">
                  <p>{{ markers[select_point].infoText.ciudad }}</p>
                  <article class="font-weight-bold"> Dirección:
                     <p class="font-weight-regular">
                        {{ markers[select_point].infoText.direccion }}
                     </p>
                  </article>
                  <article class="font-weight-bold">
                     Horario de atención:
                     <p class="font-weight-regular">
                        {{ markers[select_point].infoText.horario }} {{
                           markers[select_point].infoText.horario_atencion }}
                     </p>
                  </article>
                  <article v-if="markers[select_point].infoText.horaAlmuerzo" class="font-weight-bold">
                     Horario Almuerzo:
                     <p class="font-weight-regular">
                        {{ markers[select_point].infoText.horaAlmuerzo }}
                     </p>
                  </article>
               </v-card-text>
            </v-card>
         </gmap-info-window>

         <!-- Marcadores -->
         <GmapMarker v-for="(m, i) in markers" :key="m.position.lat + '-' + m.position.lng" :position="m.position"
            :clickable="true" @click="toggleInfoWindow(m, i)" :icon="m.icon" />
      </GmapMap>
   </section>


</template>

<script>
export default {
   name: "GoogleMap",
   props: ["points", "selectedPoint"],
   data() {
      return {
         center: { lat: 4.669926897289336, lng: -74.11707879931436 },
         infoWindowPos: null,
         infoWinOpen: false,
         select_point: null,
         infoOptions: {
            pixelOffset: {
               width: 0,
               height: -35,
            },
         },
         markers: [],
      };
   },
   mounted() {
      //console.log(this.points);
      
      this.addMarkers();
      this.$nextTick(() => {
         this.addMarkers();
      });
      document.title = "Puntos de Venta TicketShop";
   },
   methods: {
      toggleInfoWindow(marker, idx) {
         this.infoWindowPos = marker.position;
         if (this.select_point === idx) {
            this.infoWinOpen = !this.infoWinOpen;
         } else {
            this.infoWinOpen = true;
            this.select_point = idx;
         }
      },
      addMarkers() {
         this.markers = this.points
            .filter((point) => point.latitud && point.longitud)
            .map((point) => ({
               position: {
                  lat: parseFloat(point.latitud),
                  lng: parseFloat(point.longitud),
               },
               infoText: {
                  nombre: point.nombre,
                  ciudad: point.descripcion,
                  direccion: point.direccion,
                  horario: point.horario,
                  horario_atencion: point.horario_atencion,
                  horaAlmuerzo: point.hora_almuerzo,
               },
               icon: {
                  url: '/images/map-pin.svg',
                  scaledSize: new google.maps.Size(50, 81)
               }
            }));
         console.log(this.markers);

         if (this.markers.length > 0) {
            this.center = this.markers[0].position;
         }
      },
   },
   watch: {
      selectedPoint(newPoint) {
         if (newPoint) {
            const { latitud, longitud } = newPoint;
            this.center = { lat: parseFloat(latitud), lng: parseFloat(longitud) };
            setTimeout(() => {
               this.zoom = 20; // Nivel máximo permitido
            }, 100); // Ajusta el tiempo si es necesario
         }
      },
      points: {
         handler() {
            this.addMarkers();
         },
         deep: true,
         immediate: true,
      },
   },
};

</script>
